import { render, staticRenderFns } from "./dialog-redeem-voucher.vue?vue&type=template&id=6567227c&scoped=true&"
import script from "./dialog-redeem-voucher.vue?vue&type=script&lang=ts&"
export * from "./dialog-redeem-voucher.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-redeem-voucher.vue?vue&type=style&index=0&id=6567227c&lang=less&scoped=true&"
import style1 from "./dialog-redeem-voucher.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567227c",
  null
  
)

export default component.exports